





































































































import {
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";
import Widget from "@/shared/components/Widget.vue";
import moment from "moment";
import { formatCurrency } from "@/shared/currency";
import * as _ from "lodash";
import {
  CurrentInvestmentBalance,
  HealthcareExpenseForecastRequest
} from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsaLimitStore } from "@/shared/store/hsalimit";
import { useHsaTotalStore } from "@/shared/store/hsaTotal";
import { useContributionPlannerStore } from "@/employee/store/contributionPlanner";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";

const initialState: HealthcareExpenseForecastRequest = {
  birthYear: null,
  zipCode: null,
  sex: "",
  persona: "",
  usesTobacco: null,
  deductibleAmount: 0,
  maxOutOfPocket: 0,
  premium: null,
  retirementAge: null,
  currentHsaBalance: null,
  currentInvestmentBalance: null,
  employerHsaContributions: null,
  employeeHsaContributions: 0,
  conditions: [],
  minimumInvestmentBalance: null,
  familyMembers: []
};

@Component({
  components: {
    Widget,
    GenericLoadingSpinner
  }
})
export default class ContributionPlannerWidget extends Vue {

  hsaLimitStore = useHsaLimitStore();
  hsaTotalStore = useHsaTotalStore();
  contributionPlannerStore = useContributionPlannerStore();
  investmentStore = useInvestmentDailyBalanceStore();
  investmentThresholdStore = useInvestmentThresholdStore();

  formModel: HealthcareExpenseForecastRequest = { ...initialState };
  currencyFormatter = formatCurrency;
  contribValue = 0.0;
  minAnnualContribution = 0;
  isSubmitting = false;

  mounted (): void {
    this.contributionPlannerStore.loadForecastRequest();
    this.hsaLimitStore.getHsaAccountLimits();
    this.contributionPlannerStore.loadHsaForecast();
    this.hsaTotalStore.getUserPayrollSummary();
    this.investmentStore.loadCurrentDailyBalance();
    this.investmentThresholdStore.loadInvestmentThresholds();
  }

  @Watch("contributionPlannerStore.forecastRequest")
  onForecastRequestStateChanged () {
    if (this.contributionPlannerStore.isForecastRequestLoaded && this.contributionPlannerStore.forecastRequest) {
      this.cloneToCurrentModel(this.contributionPlannerStore.forecastRequest);
    }
  }

  cloneToCurrentModel (o) {
    const clonedModel = _.cloneDeep(o);
    this.formModel = clonedModel;
    this.contribValue = this.formModel.employeeHsaContributions;
  }

  get isWidgetLoaded (): boolean {
    return this.contributionPlannerStore.isForecastRequestLoaded && this.hsaTotalStore.isLoaded;
  }

  get contributionTooltip (): string {
    if (this.hsaTotalStore.employerAmount && this.hsaTotalStore.employerAmount !== 0) {
      return `Your employer contributes ${formatCurrency(
          this.hsaTotalStore.employerAmount)} so you can only contribute ${formatCurrency(
          this.hsaContributionLimit)}. This simulation assumes that the contribution amount will grow by 3% each year.`;
    } else {
      return `This simulation assumes that the contribution amount will grow by 3% each year.`;
    }
  }

  get hsaContributionLimit (): number {
    return this.hsaLimitStore.getHsaLimitByYear(moment().year()) - this.hsaTotalStore.employerAmount;
  }

  contributionChanged (e: Event) {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.formModel.employeeHsaContributions = this.contribValue;
    this.formModel.minimumInvestmentBalance = this.investmentThresholdStore.investmentThreshold as any;
    const currInvestmentBalance = this.investmentStore.singleOrDefaultCurrentBalance.balance
        + this.investmentStore.singleOrDefaultCurrentBalance.cashPositionBalance;
    this.formModel.currentInvestmentBalance = isNaN(currInvestmentBalance) ? 0 : currInvestmentBalance;
    this.contributionPlannerStore.updateHsaForecast({ ...this.formModel }).then(
        () => (this.isSubmitting = false)
    );
  }

  get hsaForecastRetirementAge (): number {
    if (!this.hasHsaForecastData) {
      return 0;
    }

    return this.formModel.retirementAge;
  }

  get hsaBalancePrediction (): string {
    if (!this.hasHsaForecastData) {
      return "";
    }
    const predictionValue = this.contributionPlannerStore.hsaForecast.hsaForecasts[
    this.contributionPlannerStore.hsaForecast.hsaForecasts.length - 1
        ].predictedHsaBalance;
    return this.currencyFormatter(predictionValue);
  }

  get currentYearOopPercent (): string {
    if (!this.hasHsaForecastData) {
      return "";
    }

    return (
        Math.round(this.contributionPlannerStore.hsaForecast.hsaForecasts[0].oopCoverageLikelihood) + "%"
    );
  }

  get hasHsaForecastData () {
    return (
        this.contributionPlannerStore.hsaForecast !== null &&
        this.contributionPlannerStore.hsaForecast.hsaForecasts !== null &&
        this.contributionPlannerStore.hsaForecast.hsaForecasts.length > 0
    );
  }
}
